import { useEffect, ChangeEvent } from 'react';
import { DocumentDataForm } from '../../../../app/models/Document';
import useHandleErrorFields from '../../../../hooks/useHandleErrorFields';
import { setCleanTextAreaError } from '../../../../utils/utils';
import ActiveControl from '../../../../components/ActiveControl';

interface Props {
    documentForm: DocumentDataForm;
    setDocumentForm: (document: DocumentDataForm) => void;
    errorFields?: any;
    setErrorFields?: (errors: any) => void;
}

const DocumentForm = ({ documentForm, setDocumentForm, errorFields, setErrorFields }: Props) => {
    const { fieldErrorMessage, fieldHasError, onFocusRemove, setErrors } = useHandleErrorFields();

    useEffect(() => {
        setErrors(errorFields);
    }, [errorFields]);

    const handleChange = (e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement> | React.ChangeEvent<HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setDocumentForm({ ...documentForm, [name]: value });
    };

    return (
        <>
            <div className="mb-2 row needs-validation">
                <label className="col-md-3 col-form-label">Nombre</label>
                <div className="col-md-9">
                    <input
                        name="document_name"
                        id="document_name"
                        type="text"
                        className={`form-control ${fieldHasError('document_name')}`}
                        value={documentForm.document_name}
                        onChange={handleChange}
                        onFocus={() => onFocusRemove('document_name')}
                        placeholder="Ingrese el nombre del Documento"
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('document_name')}
                    </div>
                </div>
            </div>

            <div className="mb-2 row">
                <label className="col-md-3 col-form-label">Descripción</label>
                <div className="col-md-9">
                    <textarea
                        className={`form-control ${fieldHasError('description')}`}
                        name="description"
                        id="description"
                        value={documentForm.description}
                        onChange={handleChange}
                        placeholder="Ingrese una descripción"
                        onFocus={setCleanTextAreaError}
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('description')}
                    </div>
                </div>
            </div>

            <div className="mb-2 row">
                <label className="col-md-3 col-form-label">Permisos por documento</label>
                <div className="col-md-9">
                    <div className="pt-2">
                        <div className="mb-3 d-flex align-items-center">
                            <ActiveControl
                                status={!!documentForm.can_upload_without_role}
                                id={1}
                                callback={(val) => setDocumentForm({
                                    ...documentForm,
                                    can_upload_without_role: val
                                })}
                            />
                            <span className="ms-3">Permitir cargar sin rol</span>
                        </div>
                        <div className="mb-3 d-flex align-items-center">
                            <ActiveControl
                                status={!!documentForm.can_view_without_role}
                                id={2}
                                callback={(val) => setDocumentForm({
                                    ...documentForm,
                                    can_view_without_role: val
                                })}
                            />
                            <span className="ms-3">Permitir ver/descargar sin rol</span>
                        </div>
                        <div className="mb-3 d-flex align-items-center">
                            <ActiveControl
                                status={!!documentForm.can_delete_without_role}
                                id={3}
                                callback={(val) => setDocumentForm({
                                    ...documentForm,
                                    can_delete_without_role: val
                                })}
                            />
                            <span className="ms-3">Permitir eliminar sin rol</span>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default DocumentForm;
